import { SxProps } from "@mui/material";

export const commonColumnStyles: SxProps = {
  width: "90%",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
};

export const actionColumnStyles: SxProps = {
  minWidth: "24px",
  height: "24px",
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  paddingRight: "4px",
};
